<div
  style="
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 15px;
  "
>
  <button
    type="button"
    mat-stroked-button
    color="primary"
    (click)="addNewClient()"
  >
    Añadir Contactos
  </button>

</div>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="Name">
    <th mat-header-cell *matHeaderCellDef class="th-title">Nombre Contacto</th>
    <td mat-cell *matCellDef="let element">
      {{ element.nameContact }}
      <br />
      {{ element.lastNameContact }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Phone">
    <th mat-header-cell *matHeaderCellDef class="th-title">Telefono</th>
    <td mat-cell *matCellDef="let element">{{ element.phoneContact }}</td>
  </ng-container>

  <ng-container matColumnDef="Email">
    <th mat-header-cell *matHeaderCellDef class="th-title">Email</th>
    <td mat-cell *matCellDef="let element">{{ element.emailContact }}</td>
  </ng-container>

  <ng-container matColumnDef="Rut">
    <th mat-header-cell *matHeaderCellDef class="th-title">Rut Cliente</th>
    <td mat-cell *matCellDef="let element">{{ element.fullRutContact }}</td>
  </ng-container>
  <ng-container matColumnDef="InfoPreferences">
    <th mat-header-cell *matHeaderCellDef class="th-title">Preferencias</th>
    <td mat-cell *matCellDef="let element">{{ element.infoPreferences }}</td>
  </ng-container>
  <ng-container matColumnDef="preferredContact">
    <th mat-header-cell *matHeaderCellDef class="th-title">
      Preferencia de Contacto
    </th>
    <td mat-cell *matCellDef="let element">{{ element.preferredContact }}</td>
  </ng-container>
  <ng-container matColumnDef="OriginRegister">
    <th mat-header-cell *matHeaderCellDef class="th-title">Registro</th>
    <td mat-cell *matCellDef="let element">{{ element.originRegister }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

  <tr
    mat-row
    [cdkContextMenuTriggerFor]="menu"
    *matRowDef="let row; columns: displayedColumns"
    class="cursor_table"
  >
    <ng-template #menu>
      <div cdkMenu class="context_menu mat-elevation-z0" style="z-index: 999">
        <li>
          <button
            class="context-menu-item"
            cdkMenuItem
            mat-raised-button
            (click)="updateInfo(row)"
          >
            Editar
          </button>
        </li>
        <li>
          <button
            class="context-menu-item trash"
            cdkMenuItem
            mat-raised-button
            (click)="deleteOwners(row)"
            style="
              background-color: rgb(250, 0, 0);
              color: white;
              font-weight: 600;
            "
          >
            Eliminar
          </button>
        </li>
      </div>
    </ng-template>
  </tr>
</table>
